<div class="bg-white rounded-10">
  <div
    class="text-center font-roboto-700 text-17 mb-3 max-sm:mb-0 p-5 max-sm:text-14 max-sm:p-3"
  >
    {{ "Standing" | translate }}
  </div>
  <nz-skeleton
    [nzActive]="true"
    [nzLoading]="loader"
    *ngIf="loader"
    class="p-5"
  >
  </nz-skeleton>

  <div nz-row *ngIf="!loader">
    <div nz-col nzSpan="24" class="font-inter-500">
      <div class="pb-5" *ngFor="let table of standingArray.tables">
        <nz-table
          class="standings-table"
          #sortTable
          [nzData]="table.rows"
          [nzShowPagination]="false"
          [nzPageSize]="table.rows.length"
        >
          <thead>
            <tr>
              <th
                class="font-inter-600 text-grey-2 !p-1 md:!p-4"
                *ngFor="let column of listOfColumn"
                [nzShowSort]="column.show"
                [nzSortFn]="column.compare"
                [nzSortPriority]="column.priority"
                nz-tooltip
                nzTooltipTitle="{{ column.tooltip }}"
                nzTooltipPlacement="top"
                [nzLeft]="column.fixed"
                [nzEllipsis]="true"
                [nzAlign]="column.align === 0 ? 'left' : 'center'"
                [nzWidth]="column.width"
              >
                {{ column.title }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let data of sortTable.data">
              <td class="!p-0 md:!p-4">
                <div
                  class="text-center mx-auto flex justify-center items-center rounded-full w-[23px] max-sm:w-[18px] text-white bg-red-2"
                >
                  {{ data.position }}
                </div>
              </td>
              <td
                [nzAlign]="'left'"
                class="cursor-pointer !p-1 md:!p-4"
                nzLeft
                [ngStyle]="{
                  'font-weight': data.color !== 'none' ? '900' : 'normal'
                }"
              >
                <div
                  class="info-team"
                  [routerLink]="[
                    '/Futbol/' +
                      utilityService.getCountry(data.country) +
                      '/team/' +
                      data.nameTeam +
                      '/' +
                      data.team_id
                  ]"
                >
                  <div class="flex gap-1 max-w-28">
                    <img
                      alt="logoTeam"
                      class="w-[20px] object-contain"
                      [src]="data.logoTeam"
                    />
                    <p class="text-wrap truncate">{{ data.nameTeam }}</p>
                  </div>
                </div>
              </td>
              <td
                [nzAlign]="'center'"
                class="td-table bg-[#FFFAEC] !w-7 !p-1 md:!p-4"
              >
                {{ data.total }}
              </td>
              <td
                [nzAlign]="'center'"
                class="td-table bg-[#ECF6EC] text-red-2 !w-7 !p-1 md:!p-4"
              >
                {{ data.won }}
              </td>
              <td
                [nzAlign]="'center'"
                class="td-table text-red-2 !w-7 !p-1 md:!p-4"
              >
                {{ data.draw }}
              </td>
              <td
                [nzAlign]="'center'"
                class="td-table bg-[#FFF3F3] text-red-2 !w-7 !p-1 md:!p-4"
              >
                {{ data.loss }}
              </td>
              <td [nzAlign]="'center'" class="td-table !w-7 !p-1 md:!p-4">
                {{ data.goal_diff }}
              </td>
              <td [nzAlign]="'center'" class="td-table !w-7 !p-1 md:!p-4">
                {{ data.points }}
              </td>
            </tr>
          </tbody>
        </nz-table>
      </div>
      <div
        class="m-5 max-sm:m-3"
        *ngIf="standingArray.promotions && standingArray.promotions.length > 0"
      >
        <div
          class="rounded-6 p-5 max-sm:p-2 max-sm:text-11"
          *ngFor="let promo of standingArray.promotions; let i = index"
          [ngStyle]="{ 'background-color': promo.color }"
          [ngClass]="{ 'mt-3 max-sm:mt-1': i }"
        >
          {{ promo.name }}
        </div>
      </div>
    </div>
  </div>
  <div
    class="font-roboto-700 text-blue-o-50 text-center pb-5"
    *ngIf="!standingArray.tables && !standingArray.promotions && !loader"
  >
    {{ "NotAvalaibleInformation" | translate }}
  </div>
</div>
